<template>
  <div class="token-body">
    <div class="token-div">
      <div class="token-contactUs">
        <div class="token-cs-title">联系我们</div>
        <div class="token-cs-content">
          <div class="content">
            <div class="content-image">
              <img src="@/assets/images/telegram.png" class="content-img" alt />
            </div>
            <div class="content-text" @click="open()">Telegram: https://t.me/TokenBoxWeb3</div>
          </div>
          <!-- <div class="content">
            <div class="content-image">
              <img
                src="@/assets/images/telephone.png"
                class="content-img"
                alt
              />
            </div>
            <div class="content-text">Telephone: XXXXX</div>
          </div>
          <div class="content">
            <div class="content-text">广告投放合作 Advertising cooperation</div>
          </div> -->
        </div>
      </div>
      <div class="token-aboutCreateToken">
        <div class="token-act-title">关于Token Box</div>
        <div class="token-act-title2">About Token Box</div>
        <div class="token-act-content">
          区块链和加密货币：<br />
          在区块链平台上，Token Box 通常用于发行新的加密货币或代币（Tokens）。这些代币可以代表各种资产，如数字商品、企业股权、服务使用权等。通过智能合约，开发者可以定义代币的总量、分配方式、交易规则等，并创建代币供用户购买和使用。<br /><br />
          身份验证和授权：<br />
          在Web应用、移动应用、API接口等场景中，
          Token Box用于生成身份验证令牌（如JWT、OAuth令牌等）。用户在通过身份验证流程后，系统会为其创建一个令牌，该令牌包含用户的身份信息和权限信息。用户在后续请求中携带这个令牌，以便系统验证用户的身份和权限，从而控制对资源的访问。<br /><br />
          支付和金融服务：<br />
          在支付系统和金融服务中，Token Box用于生成支付令牌或安全元素（Secure
          Elements），以保护用户的支付信息和交易数据。这些令牌通常与用户的银行账户、信用卡等支付账户相关联，并用于在交易过程中进行身份验证和授权。通过使用令牌代替敏感信息，可以降低数据泄露的风险。
        </div>
      </div>
      <!-- <div class="token-marketingBrandCooperation">
        <div class="token-mbc-title">市场推广，品牌合作</div>
        <div class="token-mbc-title2">Marketing, brand cooperation</div>
        <div class="token-mbc-content">
          <div class="content-image">
            <img src="@/assets/images/email.png" class="content-img" alt />
          </div>
          <div class="content-text">e-mail: XXXXX@outlook.com</div>
        </div>
        <div class="token-mbc-content">
          <div class="content-image">
            <img src="@/assets/images/telephone.png" class="content-img" alt />
          </div>
          <div class="content-text">Telephone: XXXXXX</div>
        </div>
      </div> -->
      <div class="token-technicalCooperation">
        <div class="token-tc-title">定制合约、DAPP</div>
        <div class="token-tc-title2">Customized contract APP, etc.</div>
        <div class="token-tc-content">
          <div class="content-image">
            <img src="@/assets/images/telegram.png" class="content-img" alt />
          </div>
          <div class="content-text" @click="open()">Telegram: https://t.me/TokenBoxWeb3</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods:{
    open(){
      window.open(" https://t.me/TokenBoxWeb3")
    }
  }
};
</script>

<style lang="scss" scoped>
.token-body {
  width: calc(100% - 56%);
  height: 100%;
  background: #1f1f1f;
  border-radius: 20px 20px 20px 20px;

  padding: 0 43% 0 13%;

  .token-div {
    width: 100%;
    height: 100%;

    .token-contactUs {
      width: 100%;
      height: auto;
      margin: 54px 0 0 0;

      .token-cs-title {
         font-weight: normal;
        font-size: 24px;
        color: #9b9b9b;
        line-height: 28px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin: 0 0 2px 0;
      }

      .token-cs-content {
        margin: 10px 0 0 0;

        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;

        .content {
          width: auto;
          min-width: 300px;
          height: 36px;
          background: #313131;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #909090;

          margin: 0 10px 10px 0;
          padding: 0 12px 0 12px;

          display: flex;
          justify-content: flex-start;
          align-items: center;

          .content-image {
            width: 25px;
            height: 25px;
            margin: 0 3px 0 0;

            .content-img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .content-text {
            font-weight: normal;
            font-size: 14px;
            color: #ffffff;
            line-height: 36px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            cursor: pointer;
            white-space: nowrap;
          }
        }
      }
    }

    .token-aboutCreateToken {
      width: 100%;
      height: auto;
      margin: 30px 0 0 0;

      .token-act-title {
        font-weight: normal;
        font-size: 24px;
        color: #9b9b9b;
        line-height: 28px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin: 0 0 2px 0;
      }
      .token-act-title2 {
        font-weight: normal;
        font-size: 14px;
        color: #656565;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin: 0 0 10px 0;
      }
      .token-act-content {
        font-weight: normal;
        font-size: 14px;
        color: #ffffff;
        line-height: 1.5em;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }

    .token-marketingBrandCooperation {
      width: 100%;
      height: auto;
      margin: 30px 0 0 0;

      .token-mbc-title {
        font-weight: normal;
        font-size: 24px;
        color: #9b9b9b;
        line-height: 28px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin: 0 0 2px 0;
      }
      .token-mbc-title2 {
        font-weight: normal;
        font-size: 14px;
        color: #656565;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin: 0 0 10px 0;
      }
      .token-mbc-content {
        width: auto;
        min-width: 300px;
        height: 36px;
        background: #313131;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #909090;

        margin: 0 10px 10px 0;
        padding: 0 12px 0 12px;

        display: flex;
        justify-content: flex-start;
        align-items: center;

        .content-image {
          width: 25px;
          height: 25px;
          margin: 0 3px 0 0;

          .content-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .content-text {
          font-weight: normal;
          font-size: 14px;
          color: #ffffff;
          line-height: 36px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          cursor: pointer;
          white-space: nowrap;
        }
      }
    }

    .token-technicalCooperation {
      width: 100%;
      height: auto;
      margin: 30px 0 0 0;
      padding: 0 0 54px 0;

      .token-tc-title {
        font-weight: normal;
        font-size: 24px;
        color: #9b9b9b;
        line-height: 28px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin: 0 0 2px 0;
      }
      .token-tc-title2 {
        font-weight: normal;
        font-size: 14px;
        color: #656565;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin: 0 0 10px 0;
      }
      .token-tc-content {
        width: auto;
        min-width: 300px;
        height: 36px;
        background: #313131;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #909090;

        margin: 0 10px 10px 0;
        padding: 0 12px 0 12px;

        display: flex;
        justify-content: flex-start;
        align-items: center;

        .content-image {
          width: 25px;
          height: 25px;
          margin: 0 3px 0 0;

          .content-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .content-text {
          font-weight: normal;
          font-size: 14px;
          color: #ffffff;
          line-height: 36px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          cursor: pointer;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>